import { render, staticRenderFns } from "./ContentRelease.vue?vue&type=template&id=e2271d5a&scoped=true&"
import script from "./ContentRelease.vue?vue&type=script&lang=js&"
export * from "./ContentRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2271d5a",
  null
  
)

export default component.exports